import { UploadPdfBillComponent } from '@1bill-app/components/add-bill/upload-pdf-bill/upload-pdf-bill.component';
import { UploadPhotoBillComponent } from '@1bill-app/components/add-bill/upload-photo-bill/upload-photo-bill.component';
import {
  BILL_UPLOAD_NOTE,
  IMG_FILE,
  PDF_FILE,
  ROUTE_CONNECT_EMAIL,
  ROUTE_EMAIL_BILLS,
  ROUTE_HOMEPAGE,
  ROUTE_LANDING,
  ROUTE_MOBILE_VERIFICATION,
} from '@1bill-app/constants';
import { RewardQuery } from '@1bill-app/services/reward/reward.query';
import { RewardActionCodeMapping } from '@1bill-app/services/reward/reward.type';
import { UploadCommonService } from '@1bill-app/services/upload/common/upload-common.service';
import { trigger, style, transition, animate } from '@angular/animations';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActionSheetController, NavController } from '@ionic/angular';
import { NGXLogger } from 'ngx-logger';
import { ADD_BILL_KEYS } from 'src/app/app.menu';
import { SubSink } from 'subsink';
import { BillService } from '@1bill-app/services/bill/bill.service';
@Component({
  selector: 'app-upload-bill',
  animations: [
    trigger('fadeSlideInOut', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(10px)' }),
        animate('500ms', style({ opacity: 1, transform: 'translateY(0)' })),
      ]),
      transition(':leave', [
        animate('500ms', style({ opacity: 0, transform: 'translateY(10px)' })),
      ]),
    ]),
  ],
  templateUrl: './upload-bill.page.html',
  styleUrls: ['./upload-bill.page.scss'],
})
export class UploadBillPage implements OnInit, OnDestroy {
  subs = new SubSink();
  @ViewChild('pdfUpload') pdfUpload: UploadPdfBillComponent;
  @ViewChild('photoUpload') photoUpload: UploadPhotoBillComponent;
  billUploadNote = BILL_UPLOAD_NOTE;

  landingPage = ROUTE_LANDING;
  PDF_FILE = PDF_FILE;
  IMG_FILE = IMG_FILE;
  defaultHref = ROUTE_MOBILE_VERIFICATION;
  menuClicked = false;
  billFormatKey;
  cat;
  isLoading$ = this.rewardQuery.isLoading$;
  verifyMobileRewardPoint$ = this.rewardQuery.getProfileRewardPoint(
    RewardActionCodeMapping.VERIFY_MOBILE_NUMBER,
  );
  addFirstBillPoint$ = this.rewardQuery.getProfileRewardPoint(
    RewardActionCodeMapping.ADD_FIRST_BILL,
  );
  totalProfilePoint$ = this.rewardQuery.getProfileRewardPoint(
    RewardActionCodeMapping.COMPLETE_PROFILE,
  );
  constructor(
    public actionSheetController: ActionSheetController,
    private _uploadCommon: UploadCommonService,
    private navCtrl: NavController,
    private logger: NGXLogger,
    public rewardQuery: RewardQuery,
    private billService: BillService,
  ) {}
  isOpen = true;

  toggle() {
    this.isOpen = !this.isOpen;
  }
  ngOnInit() {
    this.subs.sink = this.rewardQuery.getRewardsCache().subscribe();
    this.subs.sink = this.billService.fetchBill().subscribe();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  onClickUpload() {}

  billFormat(menuKey) {
    this.logger.log(menuKey);
    if (menuKey === ADD_BILL_KEYS.EMAIL_BILL) {
      this.emailBill();
    } else if (menuKey === ADD_BILL_KEYS.CONNECT_AC) {
      this.connectEmail();
    } else {
      this.menuClicked = true;
      this.billFormatKey = menuKey;
    }
  }

  connectEmail() {
    this.navCtrl.navigateForward([ROUTE_CONNECT_EMAIL]);
  }

  emailBill() {
    this.navCtrl.navigateForward([ROUTE_EMAIL_BILLS]);
  }

  onClickSkip() {
    this.navCtrl.navigateForward([ROUTE_HOMEPAGE]);
  }

  catSelected(cat: 'E' | 'W' | 'G' | 'I' | 'C') {
    this.logger.log(cat);
    this.cat = cat;
    this.logger.log(this.billFormatKey);

    switch (this.billFormatKey) {
      case ADD_BILL_KEYS.PDF_BILL:
        this.pdfUpload.onPdfSelectClick();
        break;
      case ADD_BILL_KEYS.PHOTO_BILL:
        this.photoUpload.onPhotoSelectClick();
        // this.photoUpload.fileInputPhoto.nativeElement.click()
        break;
      case ADD_BILL_KEYS.EMAIL_BILL:
        break;
      case ADD_BILL_KEYS.CONNECT_AC:
        break;

      default:
        break;
    }
  }

  upload(event, uploadMediaType: 'PDF' | 'PHOTO', productType, dragAndDrop: boolean = false) {
    this._uploadCommon.upload({ event, uploadMediaType, dragAndDrop, productType });
  }
}
